/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ScrollPage from "../../Components/scrollpageUp";
import "./Export.css";

function Export({ navigateWithTransition }) {
  const location = useLocation();

  const containerRef = useRef(null);
  const activeLinkRef = useRef(null);

  const handleNavigate = (path) => {
    navigateWithTransition(path);
  };

  useEffect(() => {
    if (activeLinkRef.current) {
      activeLinkRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [location.pathname]);

  return (
    <div className="ElemntsGroupPage">
      <ScrollPage />

      <nav className="PageHead">
        <ul className="PageHeadLink" ref={containerRef}>
          {[
            {
              path: "/export/projets-international",
              label: "Projets réalisés à l’international",
            },
            {
              path: "#",
              label: "Témoignages clients",
            },
            {
              path: "/export/carte",
              label: "Carte des réalisations",
            },
          ].map((item) => {
            const active = location.pathname === item.path;

            return (
              <li key={item.path}>
                <a
                  ref={active ? activeLinkRef : null}
                  className={active ? "active" : ""}
                  onClick={() => handleNavigate(item.path)}
                >
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>
      </nav>

      <Outlet />
    </div>
  );
}

export default Export;